import { createSelector } from 'reselect';

const hasValue = (val) => !!val;

export const getLiveDrawings = (state) => state.get('liveDrawing');

export const liveDrawingEditedElementIdsSelector = createSelector(
    (state) => state.get('liveDrawing'),
    (liveDrawingEditors) =>
        liveDrawingEditors
            .map(({ editedDrawingId }) => editedDrawingId)
            .filter(hasValue)
            .toArray(),
);
